module.exports = __webpack_public_path__ + "img/spartan-build-design-01-med.ff9e296b.jpg";